const LOAD_ACCOUNT = "LOAD_ACCOUNT";
const LOGOUT = "LOGOUT";

export {
    LOAD_ACCOUNT,
    LOGOUT,
};
